import { Col } from 'react-bootstrap';
import { BsCalendar, BsAward } from 'react-icons/bs';
import { Chips, ContentCard, Label } from 'ypf-pas-general-ui-components';

import './MonthlyDescriptionServiceRequest.scss';
import {
  DetailRequestMonthly,
  DetailRequestMonthlyDefaultProp
} from '../../../../utils/globalPropTypes';
import ComponentWithTooltip from '../../../../components/ComponentWithTooltip/ComponentWithTooltip';

const MonthlyDescriptionServiceRequest = ({ details }) => {
  const isOyM = details?.operacion?.length;
  const unidadesDeNegocio = isOyM ? details.operacion : details.unidadNegocio;

  return (
    <div className="card-monthly-description-service-request">
      <ContentCard className="d-flex" mark="close" orientation="vertical">
        <Col className="col-border space-left" sm={7}>
          <section className="pt-4">
            <div className="subtitle-top pt-2"> Servicio</div>
            <h2 className="title-description">{details?.servicio?.nombre}</h2>
          </section>
          <section>
            <div className="subtitle-top">Descripción</div>
            <p className="description-text">{details?.servicioDescripcion}</p>
          </section>
          <section>
            <div className="subtitle-top">UUNN</div>
            <Chips
              data={unidadesDeNegocio.map((UUNN) => ({
                ...UUNN,
                label: UUNN.nombre
              }))}
              variant="primary"
            />
          </section>
          {details?.eventos?.length ? (
            <section>
              <div className="subtitle-top">Evento</div>
              <Chips
                data={details?.eventos.map((evt) => ({
                  ...evt,
                  label: (
                    <ComponentWithTooltip id="hidden-tooltip" tooltipText={evt.nombre}>
                      {evt.sigla}
                    </ComponentWithTooltip>
                  )
                }))}
                variant="dark"
              />
            </section>
          ) : null}
        </Col>
        <Col className="pt-1 px-2" sm={5}>
          <div className="col-border-rigth d-flex pt-4">
            <Label
              fullWidth={false}
              // icon={BsCalendar}
              iconPosition="left"
              label="Tipo de asignación"
              size="md"
              sizeValue="lg"
              value={details?.tipoAsignacion?.nombre}
              variant="light"
            />
          </div>
          <div className="col-border-rigth d-flex pt-4">
            <Label
              fullWidth={false}
              icon={BsCalendar}
              iconPosition="left"
              label="Fecha de realización"
              size="md"
              sizeValue="lg"
              value={details?.mes}
              variant="light"
            />
          </div>

          <div className="d-flex">
            <Label
              fullWidth={false}
              icon={BsAward}
              iconPosition="left"
              label="Proveedor y contrato"
              size="md"
              sizeValue="lg"
              value={details ? `${details?.proveedor} (${details?.numeroContrato})` : ''}
              variant="light"
            />
          </div>
        </Col>
      </ContentCard>
    </div>
  );
};

export default MonthlyDescriptionServiceRequest;

MonthlyDescriptionServiceRequest.propTypes = {
  details: DetailRequestMonthly
};

MonthlyDescriptionServiceRequest.defaultProps = {
  details: DetailRequestMonthlyDefaultProp
};
